var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"http://oxtops.com/"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":"Oxtops Logo","width":"175"},on:{"error":_vm.loadPng}})])}
var staticRenderFns = []

export { render, staticRenderFns }